import { Route, Routes } from 'react-router-dom'
import CategoriesPage from '../../pages/shared-pages/categories/CategoriesPage'
import NewCategoryPage from '../../pages/shared-pages/categories/NewCategoryPage'
import UpdateCategoryPage from '../../pages/shared-pages/categories/UpdateCategoryPage'
import CategoryDetailsPage from '../../pages/shared-pages/categories/CategoryDetailsPage'

export default function CategoryNav() {
    return (
        <Routes>

            <Route path="/" element={<CategoriesPage />} />
            <Route path="/new" element={<NewCategoryPage />} />
            <Route path="/update" element={<UpdateCategoryPage />} />
            <Route path="/details" element={<CategoryDetailsPage />} />

        </Routes>
    )
}
